import { styled } from '../../../Utilities';
import { PersonaPresenceBase } from './PersonaPresence.base';
import { getStyles } from './PersonaPresence.styles';
/**
 * PersonaPresence is used to render an individual's presence.
 */
export var PersonaPresence = styled(PersonaPresenceBase, getStyles, undefined, {
  scope: 'PersonaPresence'
});